{
  "oneOf": {
    "IxmEmailV1EmailDataType": {
      "newAccessRequest": "New Access Request",
      "passwordChangeNotification": "Password Change Notification",
      "passwordReset": "Password Reset",
      "userInvite": "User Invite"
    },
    "IxmEmailV1EmailRequest": {
      "sendEmail": "Send Email",
      "sendTemplatedEmail": "Send Templated Email"
    }
  },
  "sortEnum": {
    "IxmEmailV1EmailSandboxServiceListEmailsSortableFields": {
      "createdAt": "Created At"
    }
  }
}